export const WHATSAPP_NUMBER = '393336450082';

export const whatsappLink = (text) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const whatsappProductLink = (product) =>
  whatsappLink(
    `Ciao, vorrei informazioni sul prezzo di "${product.name}"${product.model_code ? ` (mod. ${product.model_code})` : ''}.\n${window.location.origin}/prodotto/${product.id}`
  );
